import { Outlet } from 'react-router-dom';

import { useAbility, Subjects } from '@cast/shared-ability-data-access';

import { Navigate } from './Navigate';

type Props = {
  subject: Subjects;
};

export const ProtectedRoute = ({ subject }: Props) => {
  const rule = useAbility().relevantRuleFor('view', subject);

  if (rule?.inverted) {
    // eslint-disable-next-line no-console
    console.warn(rule.reason);
    const disabledByFeatureFlag = rule.reason?.includes('is not enabled');

    return (
      <Navigate
        to={disabledByFeatureFlag ? '/' : '/forbidden'}
        state={{ message: rule.reason }}
        replace
      />
    );
  }

  return <Outlet />;
};
